import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import SEO from "@/components/SEO";
import { Card } from "@/components/ui/card";
import PublicTicketForm from "@/components/support/PublicTicketForm";
import { Ticket, Phone } from "lucide-react";

const SupportTicket = () => (
  <>
    <SEO title="Open a Support Ticket | Neil AI Support" description="Open a Neil AI support ticket — no account required. AI Employees, voice agents, PUDU robotics, mapping, training, and more." canonical="https://www.neilai.ai/support/ticket" />
    <div className="min-h-screen bg-[#05070A] text-white pb-24">
      <Navigation />
      <section className="pt-32 md:pt-40 pb-16">
        <div className="max-w-3xl mx-auto px-4">
          <div className="text-center mb-8">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary/10 border border-primary/30 mb-4">
              <Ticket className="w-3.5 h-3.5 text-primary" />
              <span className="text-xs uppercase tracking-wider text-primary font-semibold">No account needed</span>
            </div>
            <h1 className="text-3xl md:text-5xl font-bold mb-3">Open a Support Ticket</h1>
            <p className="text-slate-300">Tell us what's happening. A specialist responds within 1 business hour — faster for urgent issues.</p>
            <p className="mt-3 text-sm text-slate-400">
              Urgent? Call <a href="tel:+13362033184" className="text-[#00F5A0] hover:underline inline-flex items-center gap-1"><Phone className="w-3 h-3" /> (336) 203-3184</a> · 24/7
            </p>
          </div>
          <Card className="bg-[#0A1828]/60 border-primary/20 p-6 md:p-8">
            <PublicTicketForm />
          </Card>
        </div>
      </section>
      <Footer />
    </div>
  </>
);
export default SupportTicket;
